import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import Card from '../card';
import Cell from '../cell';
import Amount from '../amount';
import LogisticsInfo from '../../../../neworder/index/components/logistics-info';
import GoodCard from 'src/components/goods/card-aftersale/index';
import AddressInfo from 'pages/neworder/index/components/address-info';
import ArrowRight from 'components/arrow-right';
import openLink from 'libs/open-link';
import { previewImgs } from 'utils/img-priview';
import { selectReturnInfo } from '../../selector';
import { AFTERSALE_ALL_STATUS, AFTERSALE_TYPE_NAMES, AFTERSALE_TYPE } from '../../constants';
import { AftersaleStageInfo } from '../../types';
import { sendEvent } from 'libs/event';

const isNotEmpty = (value: any) => {
    return value && Object.keys(value).length > 0 && value.data.length > 0;
};
function unitChange(cent: number) {
    return Number(cent / 100).toFixed();
}

interface IObjType {
    [key: string]: any;
}
export interface IAftersaleDetail {
    detail: IObjType;
    stageInfo: void | AftersaleStageInfo;
    orderInfo: IObjType;
    evidenceImages: string[];
    retInsInfo: any;
}

/**
 * 公共组件
 * GoodCell 订单展示
 * DetailCard 售后细节
 */
const GoodCell: React.FC<{
    orderInfo: IObjType;
    name: string;
    noBottom?: boolean;
}> = memo(({ orderInfo, name, noBottom }) => {
    return (
        <Cell className={`hair-line${!noBottom ? ' bottom p0' : ''}`}>
            {orderInfo.orders.map((order: any) => {
                const bottom = (
                    <div className="products__item__bottom">
                        <div>数量：{order.num}</div>
                        <div>
                            {name}
                            <Amount amount={order.total_amount} />
                        </div>
                    </div>
                );
                return (
                    <div key={order.product_id} className="products__item">
                        <GoodCard
                            className="px0"
                            product={{
                                ...order,
                                bottom
                            }}
                        />
                    </div>
                );
            })}
        </Cell>
    );
});
const DetailCard: React.FC<{
    detail: IObjType;
    evidenceImages: string[];
    isExchange?: boolean;
}> = memo(({ isExchange, detail, evidenceImages }) => {
    const cellTitle = isExchange ? '换货' : '退款';

    return (
        <Card>
            <Cell
                title={isExchange ? '售后类型' : '退款类型'}
                value={AFTERSALE_TYPE_NAMES[detail.after_sale_type]}
            />
            <Cell title={`${cellTitle}原因`} value={detail.reason} />
            {detail.remark && <Cell title={`${cellTitle}说明`} value={detail.remark} />}
            {evidenceImages.length ? (
                <Cell title={`${cellTitle}凭证`}>
                    <div className="evidences">
                        {evidenceImages.map((img, idx) => (
                            <img
                                onClick={() => previewImgs(evidenceImages, idx)}
                                key={`evidence-${idx}`}
                                className="evidences__img"
                                src={img}
                                alt={`${cellTitle}凭证`}
                            />
                        ))}
                    </div>
                </Cell>
            ) : null}
        </Card>
    );
});
export const Address: React.FC<{
    logistics: {
        returnAddressDesc: string;
        returnMobile: string;
        returnUserName: string;
    };
    hasBottom?: boolean;
}> = memo(({ logistics, hasBottom }) => {
    return (
        logistics &&
        logistics.returnUserName && (
            <section
                className={`aftersale-card__footer__content${hasBottom ? ' hair-line bottom' : ''}`}
            >
                <Cell
                    value={
                        <AddressInfo
                            name={logistics.returnUserName}
                            tel={logistics.returnMobile}
                            address={logistics.returnAddressDesc}
                            canChoose={false}
                            isLower={true}
                        />
                    }
                    enabledCopy
                />
            </section>
        )
    );
});

/**
 * 换货
 */
const ExchangeRender: React.FC<IAftersaleDetail> = ({
    detail,
    stageInfo,
    orderInfo,
    evidenceImages
}) => {
    const { exchange_logistics: exchangeLogistics, return_logistics: returnLogistics } =
        detail || {};
    const canMatchStatus = (arr: (keyof typeof AFTERSALE_ALL_STATUS)[]) =>
        stageInfo && arr.map((x) => AFTERSALE_ALL_STATUS[x]).includes(stageInfo.status);

    const isSendByShop = !!(
        exchangeLogistics &&
        exchangeLogistics.logistics &&
        exchangeLogistics.logistics.title
    );
    const isSendByUser = !!(returnLogistics && returnLogistics.title);
    const isShowLogistics =
        (isSendByUser || isSendByShop) &&
        canMatchStatus([
            // 用户
            '售后换货_已填写物流',
            '售后换货_已填写物流_商户拒绝',
            '售后换货_已填写物流_用户申请仲裁',
            '售后换货_已填写物流_客服支持商家',
            // 商家
            '售后换货_商家已发货',
            '售后换货_已填写物流_客服支持用户',
            '售后换货_换货成功'
        ]);
    const { exchange_post_receiver, exchange_post_tel } = exchangeLogistics || {};
    let exchange_post_addr = '';
    try {
        const cityList = JSON.parse(exchangeLogistics.exchange_post_addr || '');
        exchange_post_addr = `${['province', 'city', 'town']
            .map((x) => cityList[x].name)
            .join('')}${cityList.detail}`;
    } catch (err) {
        exchange_post_addr = exchangeLogistics.exchange_post_addr;
    }
    const logisticsInfo = isSendByShop ? exchangeLogistics.logistics : returnLogistics;
    return (
        <>
            {isShowLogistics && (
                <Card className="detail-cell">
                    <LogisticsInfo
                        orderId={orderInfo.orderId}
                        status={logisticsInfo.title}
                        time={logisticsInfo.ftime}
                        detail={logisticsInfo.context}
                        icon={require('components/v2/order/list/img/default.png')}
                        afterSaleId={detail.after_sale_id}
                        signatory=""
                        isSendByShop={isSendByShop}
                        onClickCallback={() => {
                            sendEvent('page_module_click', {
                                order_id: orderInfo.orderId,
                                module_name: 'logstics_status'
                            });
                        }}
                    />
                </Card>
            )}

            <Card className="exchange-bottom_none">
                <GoodCell name="合计：" orderInfo={orderInfo} noBottom />
            </Card>
            <DetailCard isExchange={true} detail={detail} evidenceImages={evidenceImages} />
            {!!exchange_post_receiver && (
                <Card>
                    <Cell title="收货人" value={exchange_post_receiver} />
                    <Cell title="联系电话" value={exchange_post_tel} />
                    <Cell title="收货地址" value={exchange_post_addr} />
                </Card>
            )}
        </>
    );
};

/**
 * 退货以及退款
 */
const ReturnOrRefoundRender: React.FC<IAftersaleDetail> = ({
    detail,
    stageInfo,
    orderInfo,
    evidenceImages,
    retInsInfo
}) => {
    const returnInfo = useSelector(selectReturnInfo); // 详情
    const isShowReturnInfo =
        stageInfo &&
        (stageInfo.status === AFTERSALE_ALL_STATUS.售后退货退款_商户审核_同意 ||
            stageInfo.status === AFTERSALE_ALL_STATUS.售后退货退款_客服仲裁_支持用户);

    // 控制展示物流卡片
    const isShowLogistics = stageInfo && isNotEmpty(detail.logistics);
    const { title = '', ftime = '', context = '', icon = '' } = detail.logistics
        ? detail.logistics!.data[0]
        : {};

    return (
        <>
            {isShowLogistics && (
                <Card className="detail-cell">
                    <LogisticsInfo
                        afterSaleId={detail.after_sale_id}
                        orderId={detail.order_id}
                        status={title}
                        time={ftime}
                        detail={context}
                        icon={icon}
                        signatory={detail.logistics.signatory}
                    />
                </Card>
            )}
            <Card>
                <GoodCell name="商品退款：" orderInfo={orderInfo} />
                {!!detail.refund_post_amount && (
                    <Cell
                        title="运费退款"
                        align="right"
                        value={<Amount amount={detail.refund_post_amount} />}
                    />
                )}

                <Cell
                    title="合计退款"
                    align="right"
                    value={
                        <Amount
                            className="detail-page__refund-total"
                            amount={detail.refund_amount}
                        />
                    }
                />
            </Card>
            {retInsInfo.insPolicyNo && (
                <Card>
                    <Cell
                        cellClick={() =>
                            openLink(
                                `/views/newaftersale/returnfreight?order_id=${orderInfo.orderGroupId}&ins_policy_no=${retInsInfo.insPolicyNo}&enter_from=after_sale_detail&nav_bar_color=ffffff&title_color=000000`
                            )
                        }
                        className="detail-page__return-freight"
                        title="运费险"
                        align="right"
                        value={`退款成功预计可赔${unitChange(retInsInfo.policyAmount)}元`}
                    >
                        <ArrowRight />
                    </Cell>
                </Card>
            )}
            {isShowReturnInfo && (
                <Card>
                    <Cell
                        title="退货地址"
                        value={
                            <div>
                                <div>
                                    {returnInfo.username} {returnInfo.phone}{' '}
                                </div>
                                <div>{returnInfo.address}</div>
                            </div>
                        }
                        enabledCopy
                    />
                </Card>
            )}
            <DetailCard detail={detail} evidenceImages={evidenceImages} />
            {detail.refund_card_type === 'BANK' && detail.card_no ? (
                <Card>
                    <Cell title="收款方式" value="银行卡" />
                    <Cell title="收款人姓名" value={detail.payee} />
                    <Cell title="银行卡号" value={detail.card_no} />
                    <Cell
                        title="开户银行"
                        value={
                            <div className="bank-info-wrapper">
                                <img src={detail.bank_icon} className="bank-info-icon" alt="" />
                                {detail.bank}
                            </div>
                        }
                    />
                </Card>
            ) : null}
            {detail.refund_card_type === 'ALIPAY' && detail.card_no ? (
                <Card>
                    <Cell title="收款方式" value="支付宝" />
                    <Cell title="支付宝账号" value={detail.card_no} />
                    <Cell title="姓名" value={detail.payee} />
                </Card>
            ) : null}
        </>
    );
};

const MatchAftersaleDetail: React.FC<IAftersaleDetail> = (props) => {
    // 是否是换货
    const ComponentName =
        props.detail && AFTERSALE_TYPE.Exchange === props.detail.after_sale_type
            ? ExchangeRender
            : ReturnOrRefoundRender;
    return <ComponentName {...props} />;
};

export default MatchAftersaleDetail;
